import { useSelector } from 'react-redux'
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'

import { useI18n } from 'locales'
import { currentUserLocaleSelector } from 'selectors/user'

import { MenuButtonContainer, Burger, Cross } from './styles'

const MobileButton = ({ isExpanded }) => {
  const { i18n } = useI18n()
  const locale = useSelector(currentUserLocaleSelector)
  const label = i18n.t('publisher.diagnostics.publisher_toolbar.menu', { locale })

  return (
    isExpanded ? <Cross aria-label={label} /> : <Burger aria-label={label} />
  )
}

const DesktopButton = ({ isExpanded }) => {
  const { i18n } = useI18n()
  const locale = useSelector(currentUserLocaleSelector)
  return (
    <>
      <Burger />
      {i18n.t('publisher.diagnostics.publisher_toolbar.menu', { locale })}
      {isExpanded ? <ArrowChevronUpMiniIcon /> : <ArrowChevronDownMiniIcon />}
    </>
  )
}

export const MenuButton = ({ toggleDropdown, isExpanded }) => {
  const isTabletUp = useDeviceType('isTabletUp')

  return (
    <MenuButtonContainer aria-expanded={isExpanded} onClick={toggleDropdown}>
      {
        isTabletUp
          ? <DesktopButton isExpanded={isExpanded} />
          : <MobileButton isExpanded={isExpanded} />
      }
    </MenuButtonContainer>
  )
}
